import FormHandler from '../../forms/FormHandler';
import { Country, State } from '../../forms/address/types';
import StateFilteredAddress from '../../forms/address/StateFilteredAddress';
import AnalyticsService from '../../analytics/AnalyticsService';
import { IViewItemAnalytics } from '../../analytics/types';

interface PageConfig {
  stateFilterData: { states: State[]; countries: Country[]; };
  viewItemAnalytics: IViewItemAnalytics;
}

window.tnew.page.initialize = ({ stateFilterData, viewItemAnalytics }: PageConfig) => {
  if (viewItemAnalytics) {
    AnalyticsService.trackViewItem(viewItemAnalytics);
  }

  const $form = document.querySelector('#tn-contribution-form') as HTMLFormElement;

  const formHandler = new FormHandler($form);

  StateFilteredAddress.createForCustomFormFields($form, formHandler, stateFilterData);
};
